import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "tab-content" }
const _hoisted_2 = {
  key: 0,
  class: "nome-tab"
}
const _hoisted_3 = { class: "top-left-menu-tab" }
const _hoisted_4 = { class: "window-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XL3 = _resolveComponent("XL3")!
  const _component_PowerBI = _resolveComponent("PowerBI")!

  return (_openBlock(), _createElementBlock("div", {
    class: "windows-tab",
    style: _normalizeStyle(_ctx.style),
    ref: "windowstab",
    onMouseleave: _cache[25] || (_cache[25] = ($event: any) => (_ctx.maximizeOptionsVisible=false)),
    onMousedown: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.BringToFront && _ctx.BringToFront(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "topnavbar-tab",
        onMousedown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.MouseDown($event)))
      }, [
        (_ctx.TabData!=null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.TabData.Name), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            id: "min-icon",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.Minimize && _ctx.Minimize(...args)))
          }, [...(_cache[27] || (_cache[27] = [
            _createElementVNode("svg", {
              "aria-hidden": "true",
              focusable: "false",
              viewBox: "0 0 448 512"
            }, [
              _createElementVNode("path", {
                fill: "currentColor",
                d: "M400 288h-352c-17.69 0-32-14.32-32-32.01s14.31-31.99 32-31.99h352c17.69 0 32 14.3 32 31.99S417.7 288 400 288z"
              })
            ], -1)
          ]))]),
          _createElementVNode("div", {
            id: "max-icon",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.Maximize && _ctx.Maximize(...args))),
            onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.maximizeOptionsVisible=true))
          }, [...(_cache[28] || (_cache[28] = [
            _createElementVNode("svg", {
              "aria-hidden": "true",
              focusable: "false",
              viewBox: "0 0 448 512"
            }, [
              _createElementVNode("path", {
                fill: "currentColor",
                d: "M384 31.1H64c-35.35 0-64 28.65-64 63.1v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64v-320C448 60.65 419.3 31.1 384 31.1zM400 416c0 8.822-7.178 16-16 16H64c-8.822 0-16-7.178-16-16V96c0-8.822 7.178-16 16-16h320c8.822 0 16 7.178 16 16V416z"
              })
            ], -1)
          ]))], 32),
          _createElementVNode("div", {
            id: "close-icon",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.Close && _ctx.Close(...args)))
          }, [...(_cache[29] || (_cache[29] = [
            _createElementVNode("svg", {
              "aria-hidden": "true",
              focusable: "false",
              viewBox: "0 0 320 512"
            }, [
              _createElementVNode("path", {
                fill: "currentColor",
                d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
              })
            ], -1)
          ]))])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.maximizeOptionsVisible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "maximizeOptions",
              onMouseleave: _cache[20] || (_cache[20] = ($event: any) => (_ctx.maximizeOptionsVisible=false))
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("div", {
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.LeftTab && _ctx.LeftTab(...args))),
                  style: {"border-top-left-radius":"4px","border-bottom-left-radius":"4px"}
                }),
                _createElementVNode("div", {
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.RightTab && _ctx.RightTab(...args))),
                  style: {"border-top-right-radius":"4px","border-bottom-right-radius":"4px"}
                })
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.LeftTab(false))),
                  style: {"border-top-left-radius":"4px","border-bottom-left-radius":"4px"}
                }),
                _createElementVNode("div", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.RightTab(false))),
                  style: {"border-top-right-radius":"4px","border-bottom-right-radius":"4px"}
                })
              ]),
              _createElementVNode("div", null, [
                _cache[30] || (_cache[30] = _createElementVNode("div", { style: {"border-top-left-radius":"4px","border-bottom-left-radius":"4px","grid-row":"span 2"} }, null, -1)),
                _createElementVNode("div", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.CornerTab('TR'))),
                  style: {"border-top-right-radius":"4px"}
                }),
                _createElementVNode("div", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.CornerTab('BR'))),
                  style: {"border-bottom-right-radius":"4px","grid-column":"2"}
                })
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.CornerTab('TL'))),
                  style: {"border-top-left-radius":"4px"}
                }),
                _createElementVNode("div", {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.CornerTab('TR'))),
                  style: {"border-top-right-radius":"4px"}
                }),
                _createElementVNode("div", {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.CornerTab('BL'))),
                  style: {"border-bottom-left-radius":"4px"}
                }),
                _createElementVNode("div", {
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.CornerTab('BR'))),
                  style: {"border-bottom-right-radius":"4px"}
                })
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.TopHalfTab())),
                  style: {"grid-column":"span 2","border-top-left-radius":"4px","border-top-right-radius":"4px"}
                }),
                _createElementVNode("div", {
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.BottomHalfTab())),
                  style: {"grid-column":"span 2","border-bottom-left-radius":"4px","border-bottom-right-radius":"4px"}
                })
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", {
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.TopHalfTab())),
                  style: {"grid-column":"span 2","border-top-left-radius":"4px","border-top-right-radius":"4px"}
                }),
                _createElementVNode("div", {
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.CornerTab('BL'))),
                  style: {"border-bottom-left-radius":"4px"}
                }),
                _createElementVNode("div", {
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.CornerTab('BR'))),
                  style: {"border-bottom-right-radius":"4px"}
                })
              ])
            ], 32))
          : _createCommentVNode("", true),
        (_ctx.Type == 'FsoWindowsTabData' && _ctx.TabData.Fso.objectType==_ctx.FileSystemType.XL3)
          ? (_openBlock(), _createBlock(_component_XL3, {
              key: 1,
              Path: _ctx.TabData.Fso.id,
              AdditionalUrl: _ctx.TabData.AdditionalUrl
            }, null, 8, ["Path", "AdditionalUrl"]))
          : (_ctx.Type == 'FsoWindowsTabData' && _ctx.TabData.Fso.objectType==_ctx.FileSystemType.PowerBI)
            ? (_openBlock(), _createBlock(_component_PowerBI, {
                key: 2,
                Path: _ctx.TabData.Fso.id
              }, null, 8, ["Path"]))
            : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: "resizable-r",
      onMousedown: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleResizeDown($event,'r')))
    }, null, 32),
    _createElementVNode("div", {
      class: "resizable-b",
      onMousedown: _cache[22] || (_cache[22] = ($event: any) => (_ctx.handleResizeDown($event,'b')))
    }, null, 32),
    _createElementVNode("div", {
      class: "resizable-t",
      onMousedown: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleResizeDown($event,'t')))
    }, null, 32),
    _createElementVNode("div", {
      class: "resizable-l",
      onMousedown: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleResizeDown($event,'l')))
    }, null, 32)
  ], 36))
}